/* eslint-disable max-len */

interface ActivityIconsProps {
  readonly color?: string
  readonly children?: never
}

export const MaterialIcon = () => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9983 5.96987L6.27134 10.6968C5.69225 11.2759 4.90684 11.6013
      4.08788 11.6013C3.26892 11.6013 2.48351 11.2759 1.90442 10.6968C1.32533
      10.1178 1 9.33234 1 8.51339C1 7.69443 1.32533 6.90901 1.90442 6.32992L6.6314
      1.60295C7.01746 1.21689 7.54107 1 8.08704 1C8.63301 1 9.15662 1.21689 9.54268
      1.60295C9.92874 1.98901 10.1456 2.51262 10.1456 3.05859C10.1456 3.60456 9.92874
      4.12817 9.54268 4.51423L4.81056 9.24121C4.61753 9.43424 4.35572 9.54268 4.08274
      9.54268C3.80975 9.54268 3.54795 9.43424 3.35492 9.24121C3.16189 9.04818 3.05344
      8.78637 3.05344 8.51339C3.05344 8.2404 3.16189 7.9786 3.35492 7.78557L7.72184 3.42378"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.7607 3.73265C15.8176 3.84645 15.8176 3.90334 15.8176 4.01714C15.8176 4.13094
    15.8176 4.24474 15.7607 4.35853C15.7038 4.47233 15.6469 4.52922 15.59 4.58612L4.49494
    15.6812C4.43804 15.7381 4.32424 15.795 4.26735 15.8519C4.15355 15.9088 4.09665 15.9088
    3.98286 15.9088H0.796571C0.568979 15.9088 0.398285 15.8519 0.227592 15.6812C0.0568977
    15.5105 0 15.3398 0 15.1122V11.926C0 11.8122 2.16201e-07 11.6984 0.0568982 11.6415C0.113796
    11.5277 0.170694 11.4708 0.227592 11.4139L11.3227 0.318775C11.3796 0.261877 11.4934 0.204977
    11.5503 0.148079C11.6641 0.0911813 11.7779 0.0911865 11.8917 0.0911865C12.0055 0.0911865 12.1193
    0.0911813 12.1762 0.148079C12.29 0.204977 12.3469 0.261877 12.4038 0.318775L15.59 3.50506C15.6469
    3.56196 15.7038 3.61885 15.7607 3.73265ZM3.64147 14.3157L1.59314 12.2673V14.3157H3.64147ZM11.5503
    6.40685L9.50196 4.35853L2.7311 11.1294L4.77943 13.1777L11.5503 6.40685ZM13.94 4.01714L11.8917
    1.96882L10.6399 3.22057L12.6882 5.26889L13.94 4.01714Z"
      fill="#8D8A99"
    />
  </svg>
)

export const VideoIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12" r="12" fill="#8D8A99" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5273 16.7274C13.7091 16.7274 14.7727 15.6637 14.7727 14.4819V9.51828C14.7727
      8.33646 13.7091 7.27283 12.5273 7.27283H8.74545C7.56364 7.27283 6.5 8.33646 6.5 9.51828V14.3637C6.5 15.6637 7.56364 16.7274 8.74545 16.7274H12.5273Z"
      stroke="#F4F6F9"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M14.6545 11.1726L15.4818 10.3453L16.3091 9.63622L17.1364 8.80895C17.3727 8.57259
      17.6091 8.45441 17.8455 8.45441C18.0818 8.45441 18.4364 8.45441 18.6727 8.57259C18.9091
      8.69077 19.1455 8.80895 19.2636 9.04532C19.3818 9.28168 19.5 9.63622 19.5
      9.87259V10.9362V11.9999V13.0635V14.1271C19.5 14.4817 19.3818 14.718 19.2636
      14.9544C19.1455 15.1908 18.9091 15.309 18.6727 15.4271C18.3182 15.5453 18.0818
      15.5453 17.8455 15.5453C17.6091 15.5453 17.2545 15.309 17.1364 15.1908L16.3091 14.3635L15.4818 13.5362L14.6545 12.8271"
      stroke="#F4F6F9"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
)

export const Trash = ({ color = '#D3D2D7' }: ActivityIconsProps) => (
  <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.7036 1.74414C5.56887 1.74414 5.43379 1.8083 5.3965 1.84558C5.33155 1.91054 5.29506 1.99863 5.29506 2.09049L5.29503 2.97685L8.70413 2.97685L8.70415 2.09049C8.70415 2.09048 8.70415 2.09049 8.70415 2.09049C8.70414 1.99864 8.66765 1.91053 8.6027 1.84558C8.53775 1.78063 8.44966 1.74414 8.3578 1.74414L5.7036 1.74414ZM10.2041 2.97685L10.2041 2.09051C10.2041 1.60083 10.0096 1.13118 9.66336 0.784925C9.31711 0.438667 8.84748 0.244142 8.3578 0.244142L5.7036 0.244141C5.25679 0.244141 4.70976 0.411001 4.33584 0.784923C3.98959 1.13118 3.79506 1.60079 3.79506 2.09047C3.79506 2.09046 3.79506 2.09048 3.79506 2.09047L3.79503 2.97685L2.90869 2.97685C2.70978 2.97685 2.51901 3.05587 2.37836 3.19652C2.23771 3.33717 2.15869 3.52794 2.15869 3.72685L2.15873 11.6646C2.15873 12.1543 2.35325 12.6239 2.69951 12.9702C3.04577 13.3165 3.51539 13.511 4.00508 13.511L9.9942 13.511C10.4839 13.511 10.9535 13.3165 11.2998 12.9702C11.646 12.6239 11.8405 12.1543 11.8405 11.6646L11.8405 3.72685C11.8405 3.31263 11.5047 2.97685 11.0905 2.97685L10.2041 2.97685ZM9.45409 4.47685L3.65869 4.47685L3.65873 11.6646C3.65873 11.7565 3.69522 11.8446 3.76017 11.9095C3.82512 11.9745 3.91322 12.011 4.00508 12.011L9.9942 12.011C10.0861 12.011 10.1742 11.9745 10.2391 11.9095C10.3041 11.8446 10.3405 11.7565 10.3405 11.6646L10.3405 4.47685H9.45409Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.77246 5.84082C6.18667 5.84082 6.52246 6.17661 6.52246 6.59082V9.74554C6.52246 10.1598 6.18667 10.4955 5.77246 10.4955C5.35825 10.4955 5.02246 10.1598 5.02246 9.74554V6.59082C5.02246 6.17661 5.35825 5.84082 5.77246 5.84082Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.22705 5.84082C8.64126 5.84082 8.97705 6.17661 8.97705 6.59082V9.74554C8.97705 10.1598 8.64126 10.4955 8.22705 10.4955C7.81284 10.4955 7.47705 10.1598 7.47705 9.74554V6.59082C7.47705 6.17661 7.81284 5.84082 8.22705 5.84082Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.931641 3.72656C0.931641 3.31235 1.26743 2.97656 1.68164 2.97656H12.318C12.7322 2.97656 13.068 3.31235 13.068 3.72656C13.068 4.14078 12.7322 4.47656 12.318 4.47656H1.68164C1.26743 4.47656 0.931641 4.14078 0.931641 3.72656Z"
      fill={color}
    />
  </svg>
)

export const EditActivity = () => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4204 1.4825C12.7133 1.18961 13.1881 1.18961 13.481 1.4825L16.5172 4.51864C16.6578 4.6593 16.7368 4.85006 16.7368 5.04897C16.7368 5.24789 16.6578 5.43865 16.5172 5.5793L7.01637 15.0801C6.89296 15.2035 6.73037 15.28 6.55662 15.2964L3.20357 15.6134C2.98104 15.6344 2.76072 15.5551 2.60266 15.3971C2.44461 15.239 2.36528 15.0187 2.38631 14.7962L2.70322 11.443C2.71964 11.2693 2.79615 11.1067 2.91956 10.9833L12.4204 1.4825ZM12.9507 3.07349L4.17116 11.853L3.96496 14.0347L6.14664 13.8285L14.9262 5.04897L12.9507 3.07349Z"
      fill="#D3D2D7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7367 7.63782L10.3617 4.26281L11.4224 3.20215L14.7974 6.57717L13.7367 7.63782Z"
      fill="#D3D2D7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.70185 14.1264L3.87342 11.298L4.93408 10.2373L7.76251 13.0657L6.70185 14.1264Z"
      fill="#D3D2D7"
    />
  </svg>
)

export const Link = () => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.39111 9.44346C7.6442 9.78181 7.9671 10.0618 8.3379 10.2644C8.7087 10.4669 9.11873 10.5874 9.54019 10.6176C9.96164 10.6478 10.3847 10.587 10.7805 10.4393C11.1764 10.2916 11.5359 10.0605 11.8346 9.76169L13.6026 7.99371C14.1394 7.43796 14.4364 6.69364 14.4297 5.92104C14.423 5.14844 14.1131 4.40938 13.5667 3.86305C13.0204 3.31672 12.2814 3.00683 11.5088 3.00011C10.7362 2.9934 9.99183 3.2904 9.43608 3.82716L8.42244 4.83491"
      stroke="#D3D2D7"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.74815 8.26565C9.49506 7.9273 9.17217 7.64734 8.80136 7.44475C8.43056 7.24217 8.02053 7.1217 7.59908 7.09151C7.17762 7.06133 6.75461 7.12214 6.35872 7.26982C5.96283 7.41749 5.60334 7.64858 5.30461 7.94741L3.53663 9.7154C2.99988 10.2711 2.70287 11.0155 2.70958 11.7881C2.7163 12.5607 3.02619 13.2997 3.57252 13.8461C4.11886 14.3924 4.85791 14.7023 5.63051 14.709C6.40311 14.7157 7.14744 14.4187 7.70318 13.882L8.71093 12.8742"
      stroke="#D3D2D7"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Show = ({ show }: { readonly show: boolean }) => {
  if (show) {
    return (
      <svg
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.13269 9.07373C4.17615 9.14599 4.22689 9.2279 4.28478 9.31754C4.51942 9.68085 4.86656 10.1634 5.31625 10.643C6.2293 11.617 7.47635 12.4883 8.99871 12.4883C10.5211 12.4883 11.7681 11.617 12.6812 10.643C13.1309 10.1634 13.478 9.68085 13.7126 9.31754C13.7705 9.22791 13.8213 9.14599 13.8647 9.07372C13.8213 9.00146 13.7705 8.91955 13.7126 8.82991C13.478 8.46661 13.1309 7.98407 12.6812 7.50441C11.7681 6.53049 10.5211 5.65918 8.99871 5.65918C7.47635 5.65918 6.2293 6.53049 5.31625 7.50441C4.86656 7.98407 4.51942 8.46661 4.28478 8.82991C4.22689 8.91955 4.17615 9.00146 4.13269 9.07373ZM14.725 9.07373C15.3958 8.73832 15.3957 8.73807 15.3955 8.73781L15.3952 8.73721L15.3945 8.73571L15.3924 8.73159L15.3859 8.71886C15.3805 8.70842 15.3731 8.6941 15.3636 8.67617C15.3446 8.64031 15.3174 8.58992 15.2821 8.52708C15.2114 8.40151 15.108 8.22562 14.9727 8.01612C14.703 7.59857 14.3019 7.03997 13.7755 6.4785C12.7364 5.37015 11.1203 4.15918 8.99871 4.15918C6.87709 4.15918 5.26102 5.37015 4.22194 6.4785C3.69556 7.03997 3.29439 7.59857 3.02472 8.01612C2.88942 8.22562 2.786 8.40151 2.71537 8.52708C2.68002 8.58992 2.6528 8.64031 2.63383 8.67617C2.62434 8.6941 2.6169 8.70842 2.61153 8.71886L2.60503 8.73159L2.60295 8.73571L2.6022 8.73721L2.60189 8.73781C2.60176 8.73807 2.60164 8.73832 3.27246 9.07373L2.60164 8.73832C2.49607 8.94946 2.49607 9.19799 2.60164 9.40914L3.27246 9.07373C2.60164 9.40914 2.60176 9.40938 2.60189 9.40964L2.6022 9.41025L2.60295 9.41174L2.60503 9.41587L2.61153 9.42859C2.6169 9.43903 2.62434 9.45335 2.63383 9.47128C2.6528 9.50714 2.68002 9.55753 2.71537 9.62037C2.786 9.74594 2.88942 9.92184 3.02472 10.1313C3.29439 10.5489 3.69556 11.1075 4.22194 11.669C5.26102 12.7773 6.87709 13.9883 8.99871 13.9883C11.1203 13.9883 12.7364 12.7773 13.7755 11.669C14.3019 11.1075 14.703 10.5489 14.9727 10.1313C15.108 9.92184 15.2114 9.74594 15.2821 9.62037C15.3174 9.55753 15.3446 9.50714 15.3636 9.47128C15.3731 9.45335 15.3805 9.43903 15.3859 9.42859L15.3924 9.41587L15.3945 9.41174L15.3952 9.41025L15.3955 9.40964C15.3957 9.40938 15.3958 9.40914 14.725 9.07373ZM14.725 9.07373L15.3958 9.40914C15.5014 9.19799 15.5014 8.94946 15.3958 8.73832L14.725 9.07373Z"
          fill="#D3D2D7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.99872 8.26172C8.55042 8.26172 8.18701 8.62513 8.18701 9.07342C8.18701 9.52172 8.55042 9.88513 8.99872 9.88513C9.44701 9.88513 9.81042 9.52172 9.81042 9.07342C9.81042 8.62513 9.44701 8.26172 8.99872 8.26172ZM6.68701 9.07342C6.68701 7.7967 7.722 6.76172 8.99872 6.76172C10.2754 6.76172 11.3104 7.7967 11.3104 9.07342C11.3104 10.3501 10.2754 11.3851 8.99872 11.3851C7.722 11.3851 6.68701 10.3501 6.68701 9.07342Z"
          fill="#D3D2D7"
        />
      </svg>
    )
  }
  return (
    <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.64338 5.63643L13.528 9.52463C13.6469 9.35338 13.7598 9.17796 13.8664 8.99869C13.823 8.92654 13.7724 8.84479 13.7146 8.75535C13.4799 8.39198 13.1327 7.90936 12.683 7.4296C11.9019 6.59647 10.8765 5.83841 9.64338 5.63643ZM14.727 8.99929L15.3978 8.66388C15.5066 8.88146 15.5031 9.1383 15.3884 9.35285C15.0478 9.99015 14.6415 10.5901 14.1762 11.1431C14.0409 11.3039 13.8444 11.4005 13.6344 11.4095C13.4244 11.4185 13.2203 11.339 13.0718 11.1903L7.37577 5.48904C7.18341 5.29651 7.11045 5.01488 7.18513 4.75316C7.25981 4.49144 7.47041 4.29072 7.73541 4.22869C8.15012 4.13162 8.5747 4.08306 9.00061 4.084C11.1221 4.08433 12.7381 5.2953 13.7773 6.40369C14.3037 6.96525 14.705 7.52395 14.9747 7.94157C15.11 8.1511 15.2134 8.32702 15.2841 8.45261C15.3194 8.51546 15.3467 8.56585 15.3656 8.60172C15.3751 8.61966 15.3826 8.63398 15.3879 8.64442L15.3944 8.65715L15.3965 8.66127L15.3973 8.66277L15.3976 8.66337C15.3977 8.66363 15.3978 8.66388 14.727 8.99929ZM9.00061 4.084C9.00091 4.084 9.0012 4.084 9.0015 4.084L8.99973 4.834V4.084C9.00003 4.084 9.00032 4.084 9.00061 4.084ZM5.45183 5.31048C5.75043 5.08246 6.17167 5.11057 6.43734 5.37623L8.42332 7.36221C8.42506 7.36394 8.4268 7.36568 8.42853 7.36742L10.6316 9.57048C10.6333 9.57222 10.6351 9.57396 10.6368 9.57571L12.6228 11.5617C12.7758 11.7147 12.8553 11.9264 12.8408 12.1423C12.8263 12.3582 12.7192 12.5573 12.5471 12.6885C11.5298 13.464 10.291 13.8936 9.01199 13.9145L8.99973 13.9147V13.9146C6.87779 13.9146 5.26146 12.7034 4.22221 11.5949C3.69574 11.0333 3.2945 10.4746 3.02479 10.057C2.88947 9.84748 2.78603 9.67155 2.71539 9.54596C2.68004 9.48311 2.65281 9.43272 2.63383 9.39685C2.62434 9.37892 2.6169 9.3646 2.61153 9.35416L2.60503 9.34143L2.60295 9.3373L2.6022 9.33581L2.60189 9.3352C2.60176 9.33494 2.60164 9.3347 3.27246 8.99929L2.60164 9.3347C2.49266 9.11673 2.49637 8.8594 2.61159 8.64467C3.3098 7.34349 4.2782 6.20667 5.45183 5.31048ZM4.13348 9.0006C4.17678 9.07257 4.22728 9.15408 4.28485 9.24322C4.51953 9.60659 4.86674 10.0892 5.31651 10.569C6.22852 11.5418 7.47371 12.4122 8.99363 12.4146C9.65695 12.4028 10.3057 12.2445 10.8949 11.9551L10.0286 11.0888C9.98702 11.1105 9.9447 11.1309 9.90174 11.1501C9.61814 11.2764 9.31199 11.3444 9.00156 11.3499C8.69113 11.3554 8.38277 11.2982 8.09489 11.182C7.80701 11.0657 7.54549 10.8926 7.32595 10.6731C7.10641 10.4535 6.93334 10.192 6.81706 9.90413C6.70077 9.61625 6.64367 9.30789 6.64915 8.99746C6.65462 8.68703 6.72257 8.38088 6.84894 8.09728C6.86808 8.05432 6.88851 8.012 6.91018 7.97039L5.85786 6.91807C5.18024 7.51957 4.59854 8.22185 4.13348 9.0006ZM8.17239 9.2326C8.18158 9.2699 8.19343 9.30657 8.20788 9.34235C8.24872 9.44346 8.30951 9.5353 8.38661 9.61241C8.46372 9.68951 8.55556 9.7503 8.65667 9.79114C8.69245 9.80559 8.72912 9.81744 8.76642 9.82663L8.17239 9.2326Z"
        fill="#625F6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.74213 2.74213C3.03502 2.44924 3.5099 2.44924 3.80279 2.74213L15.2573 14.1967C15.5502 14.4896 15.5502 14.9644 15.2573 15.2573C14.9644 15.5502 14.4896 15.5502 14.1967 15.2573L2.74213 3.80279C2.44924 3.5099 2.44924 3.03502 2.74213 2.74213Z"
        fill="#625F6D"
      />
    </svg>
  )
}

export const Duplicate = () => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 9.35021C8.5 9.47824 8.60379 9.58203 8.73182 9.58203L13.1929 9.58203C13.3209 9.58203 13.4247 9.47824 13.4247 9.35021L13.4247 4.93204C13.4247 4.80401 13.3209 4.70022 13.1929 4.70022L8.73182 4.70022C8.60379 4.70022 8.5 4.80401 8.5 4.93204L8.5 9.35021ZM8.73182 11.082C7.77536 11.082 7 10.3067 7 9.35021L7 4.93204C7 3.97558 7.77536 3.20022 8.73182 3.20022L13.1929 3.20022C14.1494 3.20022 14.9247 3.97558 14.9247 4.93204L14.9247 9.35021C14.9247 10.3067 14.1494 11.082 13.1929 11.082L8.73182 11.082Z"
      fill="#D3D2D7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.84082 12.9274C4.84082 12.9888 4.86524 13.0478 4.90872 13.0913C4.95219 13.1348 5.01116 13.1592 5.07264 13.1592L9.70564 13.1592C9.76712 13.1592 9.82609 13.1348 9.86956 13.0913C9.91303 13.0478 9.93746 12.9888 9.93746 12.9274L9.93746 12.0001L11.4375 12.0001L11.4375 12.9274C11.4375 13.3867 11.255 13.8272 10.9302 14.1519C10.6054 14.4767 10.1649 14.6592 9.70564 14.6592L5.07264 14.6592C4.61333 14.6592 4.17284 14.4767 3.84806 14.1519C3.52328 13.8272 3.34082 13.3867 3.34082 12.9274L3.34082 8.29439C3.34082 7.83509 3.52328 7.39459 3.84806 7.06981C4.17284 6.74504 4.61333 6.56258 5.07264 6.56258L5.99994 6.56258L5.99994 8.06258L5.07264 8.06258C5.01116 8.06258 4.95219 8.087 4.90872 8.13047C4.86524 8.17395 4.84082 8.23291 4.84082 8.29439L4.84082 12.9274Z"
      fill="#D3D2D7"
    />
  </svg>
)

export const MultipleActivity = () => (
  <svg width={18} height={10} viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x={9}
      y={9}
      width={8}
      height={8}
      rx={1}
      transform="rotate(-180 9 9)"
      stroke="black"
      strokeWidth={2}
    />
    <path d="M13 9L13 1" stroke="black" strokeWidth={2} strokeLinecap="round" />
    <path d="M17 9L17 1" stroke="black" strokeWidth={2} strokeLinecap="round" />
  </svg>
)

export const VideoIconDark = ({ color = '#D3D2D7' }: ActivityIconsProps) => (
  <svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H28C31.3137 0 34 2.68629 34 6V20C34 23.3137 31.3137 26 28 26H6C2.68629 26 0 23.3137 0 20V6Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9998 8.6073C22.8139 7.92883 24.05 8.50778 24.05 9.56757V16.4325C24.05 17.4923 22.8139 18.0713 21.9998 17.3928L18.5 14.4763V11.5238L21.9998 8.6073ZM22.55 10.1013L20 12.2263V13.7738L22.55 15.8988V10.1013Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.95001 10.5C9.95001 8.98122 11.1812 7.75 12.7 7.75L17.1871 7.75C18.7058 7.75 19.9371 8.98122 19.9371 10.5V15.5C19.9371 17.0188 18.7058 18.25 17.1871 18.25L12.7 18.25C11.1812 18.25 9.95001 17.0188 9.95001 15.5V10.5ZM12.7 9.25C12.0097 9.25 11.45 9.80964 11.45 10.5V15.5C11.45 16.1904 12.0097 16.75 12.7 16.75L17.1871 16.75C17.8774 16.75 18.4371 16.1904 18.4371 15.5V10.5C18.4371 9.80965 17.8774 9.25 17.1871 9.25L12.7 9.25Z"
      fill="black"
    />
  </svg>
)

export const Add = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0.95459C6.41421 0.95459 6.75 1.29038 6.75 1.70459V10.2955C6.75 10.7097 6.41421 11.0455 6 11.0455C5.58579 11.0455 5.25 10.7097 5.25 10.2955V1.70459C5.25 1.29038 5.58579 0.95459 6 0.95459Z"
      fill="#121019"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.95459 6C0.95459 5.58579 1.29038 5.25 1.70459 5.25H10.2955C10.7097 5.25 11.0455 5.58579 11.0455 6C11.0455 6.41421 10.7097 6.75 10.2955 6.75H1.70459C1.29038 6.75 0.95459 6.41421 0.95459 6Z"
      fill="#121019"
    />
  </svg>
)
